export class Pagination {
  page: any;
  size: any;
  sort?: any;

  constructor(page: any = 0, size: any = 10, sort: any = '') {
    this.page = page;
    this.size = size;
    this.sort = sort;
  }

  static fromPrimeNg(primeEvent: any): Pagination {
    let pagination = new Pagination();
    pagination.page = primeEvent.first / primeEvent.rows;
    pagination.size = primeEvent.rows;
    const sortOrder = primeEvent.sortOrder > 0 ? 'ASC' : 'DESC';
    if (primeEvent.sortField) {
      pagination.sort = `${primeEvent.sortField},${sortOrder}`;
    }
    return pagination;
  }

  nextPage(): Pagination {
    this.page += 1;
    return this;
  }

}
